<kendo-stacklayout [formGroup]="form" orientation="horizontal" gap="50">
  <div class="row">
    <div class="buffer">&nbsp;</div>
    @for(control of controls; track control){
      <div class="control">
        <app-kendo-card-form-control [form]="form" [control]="control" [submitted]="submitted"></app-kendo-card-form-control>
      </div>
    }
    <div class="spacer">&nbsp;</div>
  </div>
</kendo-stacklayout>
